export default __webpack_public_path__ + "static/media/Gung Si.2add1224.jpg";